import { createAsyncThunk } from "@reduxjs/toolkit";
import { updateComment as updateCommentInFirestore } from "../../../firebase/commentsApi";

export const updateComment = createAsyncThunk(
  "comments/updateComment",
  async ({ commentId, text, postId }, { rejectWithValue }) => {
    try {
      await updateCommentInFirestore(commentId, { text });
      return {
        commentId,
        text,
        postId,
        updatedAt: new Date().toISOString(),
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
